import { render, staticRenderFns } from "./SolAgoraStep2.vue?vue&type=template&id=73c77a31&scoped=true&"
import script from "./SolAgoraStep2.vue?vue&type=script&lang=js&"
export * from "./SolAgoraStep2.vue?vue&type=script&lang=js&"
import style0 from "./SolAgoraStep2.vue?vue&type=style&index=0&id=73c77a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c77a31",
  null
  
)

export default component.exports